import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { userFarmDetail } from "../../../config/farmDetails";
import { updateContract } from "../../../modules/contract/action";
import "../../../style";
import ContractForm from "./ContractForm";



class EditContract extends Component {
  constructor(props) {
    super(props);

    this.state = {
      contractInfo: {
        farmId: "",
        contractNumber: "", //long
        contractTypeId: "", //long
        maturityDate: "",
        counterpartId: "", //long
        destinationId: "", //long
        contractStageId: "",
        commodityId: "", //long
        commodityVarietyId: "", //long
        bushelContracted: "", //float
        unitPrice: "", //float
        basis: "", //float
        notes: null
      },
      successMessage: "",
      isValid: false
    };
  }

  componentWillMount() {
    const { EditContract } = this.props;
    if (!EditContract) {
      this.props.route.history.push("/app/contracts");
    } else {
      let date = new Date(EditContract.maturityDate);
      date = EditContract.maturityDate;
      this.setState({
        contractInfo: {
          createdBy: EditContract.createdBy,
          updatedBy: EditContract.updatedBy,
          createdAt: EditContract.createdAt,
          updatedAt: EditContract.updatedAt,
          farmId: this.props.SubFarmId
            ? this.props.SubFarmId
            : userFarmDetail().id || this.props.MainFarmId,
          contractNumber: EditContract.contractNumber,
          contractTypeId: EditContract.contractType.id,
          maturityDate: EditContract.maturityDate,
          counterpartId: EditContract.counterpartResponseDTO
            ? EditContract.counterpartResponseDTO.id
            : "",
          destinationId: EditContract.destination
            ? EditContract.destination.id
            : "",
          contractStageId: EditContract.contractStageResponseDTO.id,
          commodityId: EditContract.commodityVarietyResponseDTO
            ? EditContract.commodityVarietyResponseDTO.commodityResponseDTO.id
            : "",
          commodityVarietyId: EditContract.commodityVarietyResponseDTO
            ? EditContract.commodityVarietyResponseDTO.id
            : "",
          bushelContracted: EditContract.bushelContracted,
          unitPrice: EditContract.unitPrice,
          basis: EditContract.basis,
          notes: EditContract.notes
        }
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.ContractUpdated && nextProps.ContractUpdated.status === 200) {
      this.setState({ successMessage: true });
    }
  }

  handleChange = (name, value) => {
    if (name === "bushelContracted" || name === "unitPrice") {
      if (value.match(/^\d{0,10}(\.\d{0,2})?$/)) {
        this.setState(prevState => {
          return {
            contractInfo: {
              ...prevState.contractInfo,
              [name]: value
            }
          };
        });
      }
    } else if (name === "basis") {
      if (value.match(/^[-]?\d{0,10}(\.\d{0,2})?$/)) {
        this.setState(prevState => {
          return {
            contractInfo: {
              ...prevState.contractInfo,
              [name]: value
            }
          };
        });
      }
    } else {
      this.setState(prevState => {
        return {
          contractInfo: {
            ...prevState.contractInfo,
            [name]: value
          }
        };
      });
    }
  };

  updateContract = contractInfo => {
    this.props.actions.updateContract(contractInfo);
  };

  render() {
    const { contractInfo, successMessage, isValid } = this.state;
   
    if (successMessage) {
      return <Redirect to="/app/contracts" />;
    }

    return (
      <ContractForm
        formLabel="Edit Contract"
        buttonLabel="Update"
        contractInfo={contractInfo}
        changeFunction={this.handleChange}
        submitFunction={this.updateContract}
        isValid={isValid}
        editMode={true}
      />
    );
  }
}
function mapStateToProps(state) {
  return {
    EditContract: state.contractReducer.EditSelectedContract,
    ContractUpdated: state.contractReducer.ContractUpdated,
    SubFarmId: state.FarmManagementReducer.SubFarmId,
    MainFarmId: state.FarmManagementReducer.MainFarmId
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        updateContract
      },
      dispatch
    )
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditContract);



// WEBPACK FOOTER //
// ./src/components/private/Contracts/EditContract.js